<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template
						span
								| {{ $i18n.tc('trainer.trainer_gameFormSetting_tableSize', 1) }}:
								| {{ settings.difficult + ' x ' + settings.difficult }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.numOfExamples }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_portal') }}:
								| {{ settings.portal === 0 ? $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') : settings.portal}}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_field') }}:
								| {{ settings.isFieldOpened ? $i18n.t('trainer.trainer_gameFormSettingValue_opened') : $i18n.t('trainer.trainer_gameFormSettingValue_closed')}}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfSteps') }}:
								| {{ settings.amountOfSteps}}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}:
								| {{ settings.speed }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
						br
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
